import React, { useState, useEffect } from 'react'

import ProductHeroLayout from './ProductHeroLayout';
import { Container, Grid, TextField, Button, Typography, createTheme, Box } from '@mui/material'
import LoginIcon from '@mui/icons-material/Login';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
const images = ['../img/BannerDistance.jpg'];


export default function ProductHero() {



    const month = new Date().getMonth()

    var thisYear = ''
    if (month >= 8) {
        thisYear = new Date().getFullYear() + 1
    } else {
        thisYear = new Date().getFullYear()
    }

    const [backgroundImage, setBackgroundImage] = useState(images[0])


    return (
        <ProductHeroLayout
            fullWidth
            sxBackground={{
                backgroundImage: `url(${backgroundImage})`,
                backgroundColor: '#7fc7d9', // Average color of the background image.
                fullWidth: 'calc(85vh)',
                transition: 'background 3s linear',
                marginTop: 0,


            }}
        >
            {/* Increase the network loading priority of the background image. */}
            <img
                style={{ display: 'none' }}
                src={backgroundImage}
                alt="increase priority"
            />

            <Box mb={10} />
            <Typography color="inherit" align="center" variant="h3" marked="center" fontFamily="Times New Roman" >
                British International Distance College
            </Typography>
            <Typography color="inherit" align="center" variant="h4" marked="center" fontFamily="Times New Roman" >
                Online Registration Portal
            </Typography>
            {month === 9 && (

                <Typography color="inherit" align="center" variant="h4" marked="center" fontFamily="Times New Roman" >
                    <i>{thisYear} early bird special now available for the month of October.</i>
                </Typography>
            )}
            {month !== 8 && month !== 9 && month !== 7 && (

                <Typography color="inherit" align="center" variant="h4" marked="center" fontFamily="Times New Roman" >
                    <i>{thisYear} registrations now available.</i>
                </Typography>
            )}

            {month === 8 && (

                <Typography color="inherit" align="center" variant="h4" marked="center" fontFamily="Times New Roman" >
                    <i>{thisYear} registrations open 1 October. </i>
                </Typography>
            )}
            {month === 7 && (

                <Typography color="inherit" align="center" variant="h4" marked="center" fontFamily="Times New Roman" >
                    <i>{thisYear} registrations closing soon. </i>
                </Typography>
            )}
            <Typography
                color="inherit"
                align="center"
                variant="body2"
                fontSize={"16px"}
                sx={{ mb: 4, mt: { xs: 4, sm: 10 } }}


            >
                Welcome to the British International Distance College online registration portal. Parents or Guardians of students can login and register a student for Distance learning courses. If you already have an account click the login button, alternatively, click the register button to create your BIDC Online Registration account.
            </Typography>
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"

            >
                <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 12, xl: 12 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >
                            <Button
                                color="primary"
                                variant="contained"
                                size="large"
                                component="a"
                                href="/register"
                                sx={{ minWidth: 200 }}
                            >
                                Register <AppRegistrationIcon />
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"

                        >
                            <Button
                                color="secondary"
                                variant="contained"
                                size="large"
                                component="a"
                                href="/login"
                                sx={{ minWidth: 200 }}
                            >
                                Login <LoginIcon />
                            </Button>
                        </Box>
                    </Grid>
                </Grid>
            </Box>
            <Typography variant="body2" color="inherit" sx={{ mt: 2, fontStyle: 'italic' }}>
                <a class="buttonIllum"><span> Illuminate et Optimus</span></a>
            </Typography>

            <Typography variant="body2" color="inherit" sx={{ bottom: 0, marginTop: 'auto', mt: 2, fontStyle: 'italic', color: 'white', textDecoration: 'none' }}>
                View website <a style={{ color: 'white' }} href='https://dcreg.bi-oss.co.za/tnc' target='_blank'>Terms and Conditions</a>
            </Typography>
        </ProductHeroLayout>
    );
}